<template>
  <router-link :to="sideBarSubItem?.RouterName" class="nav-link">
    {{ $t(sideBarSubItem?.DisplayNameLocalizationCode) }}
  </router-link>
  <!-- class="nav-link active" -->
</template>
<script>
import { SideBarSubItemModel } from "@/models/sideBarModel/sideBarModel.js";

export default {
  data() {
    return {};
  },
  props: {
    sideBarSubItem: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    // console.log("sideBarSubItem prop:", this.sideBarSubItem);
  },
};
</script>
<style></style>
